import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { DynamicScript, LoadScripts } from '../../../shared/load-scripts.function';

// @dynamic
@Injectable({ providedIn: 'root' })
export class FidelJsLoaderService {
  static behaviourSubject: BehaviorSubject<any>;

  constructor() {}

  /**
   * Loads the required js for fidel to work
   *
   * @example
   * this.fidelJsLoaderService.loadJs().pipe(delay(100))
   * .subscribe((status) => {
   *   if (status == 'loaded') {
   *   this.fidelService.linkcard("test");
   *   }
   * });
   */
  loadJs(): Observable<any> {
    if (FidelJsLoaderService.behaviourSubject == null) {
      FidelJsLoaderService.behaviourSubject = new BehaviorSubject<any>('initializing');

      LoadScripts([{ src: 'https://resources.fidel.uk/sdk/js/v3/fidel.js' }] as DynamicScript[]).then(() => {
        FidelJsLoaderService.behaviourSubject.next('loaded');
      });
    }

    return FidelJsLoaderService.behaviourSubject.asObservable();
  }
}
